import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import OpenInNewIcon from '@material-ui/icons/OpenInNew';
export const _frontmatter = {
  "title": "Information Quality",
  "layout": "content",
  "includeToc": true,
  "permalink": "/information-quality/"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "Information-Quality",
      "style": {
        "position": "relative"
      }
    }}>{`Information Quality`}</h1>
    <p>{`All information disseminated by ONRR must comply with basic standards of quality to ensure and maximize its objectivity, utility, integrity, and quality. ONRR will ensure that information disseminated will be developed from reliable methods and data sources and will otherwise ensure information quality at each stage of information development. `}</p>
    <br />
    <p>{`ONRR’s methods for producing quality information will be made transparent, to the maximum extent practicable, through:`}</p>
    <ul>
      <li parentName="ul">{`Accurate documentation;`}</li>
      <li parentName="ul">{`Use of appropriate internal and external review procedures;`}</li>
      <li parentName="ul">{`Consultation with experts and users;`}</li>
      <li parentName="ul">{`Verification of quality; and`}</li>
      <li parentName="ul">{`Informing its users on corrections and revisions.`}</li>
    </ul>
    <p>{`Information released by ONRR will be developed only from reliable data sources based on accepted practices and policies, utilizing accepted methods for information collection and verification. `}</p>
    <h2 {...{
      "id": "Information-Quality-Act-Requirements",
      "style": {
        "position": "relative"
      }
    }}>{`Information Quality Act Requirements`}</h2>
    <ul>
      <li parentName="ul">{`Overall, agencies shall adopt a basic standard of quality (including objectivity, utility, and integrity) as a performance goal and should take appropriate steps to incorporate information quality criteria into agency information dissemination practices. Quality is to be ensured and established at levels appropriate to the nature and timeliness of the information to be disseminated. Agencies shall adopt specific standards of quality that are appropriate for the various categories of information they disseminate.`}</li>
      <li parentName="ul">{`As a matter of good and effective agency information resources management, agencies shall develop a process for reviewing the quality (including the objectivity, utility, and integrity) of information before it is disseminated. Agencies shall treat information quality as integral to every step of an agency's development of information, including creation, collection, maintenance, and dissemination. This process shall enable the agency to substantiate the quality of the information it has disseminated through documentation or other means appropriate to the information.`}</li>
      <li parentName="ul">{`To facilitate citizen review, agencies shall establish administrative mechanisms allowing affected persons to seek and obtain, where appropriate, timely correction of information maintained and disseminated by the agency that does not comply with OMB or agency guidelines. These administrative mechanisms shall be flexible, appropriate to the nature and timeliness of the disseminated information and incorporated into agency information resources management and administrative practices.`}</li>
    </ul>
    <h2 {...{
      "id": "Information-Quality-Directives-Policies-and-Guidelines",
      "style": {
        "position": "relative"
      }
    }}>{`Information Quality Directives, Policies, and Guidelines`}</h2>
    <p>{`The following list provides governing authorities for the Information Quality Act.`}</p>
    <ul>
      <li parentName="ul">{`Office of Management and Budget (OMB) has issued `}<a parentName="li" {...{
          "href": "https://obamawhitehouse.archives.gov/omb/fedreg_final_information_quality_guidelines/"
        }}>{`"Guidelines for Ensuring and Maximizing the Quality, Objectivity, Utility, and Integrity of Information Disseminated by Federal Agencies" `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://georgewbush-whitehouse.archives.gov/omb/memoranda/fy2005/m05-03.html"
        }}>{`The Office of Management and Budget directive, Final Information Quality Bulletin for Peer Review, dated December 15, 2004 `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" />{`.`}</a></li>
      <li parentName="ul">{`Department of the Interior issued `}<a parentName="li" {...{
          "href": "https://www.doi.gov/sites/doi.gov/files/uploads/doi_information_quality_guidelines.pdf"
        }}>{`Information Quality Guidelines (PDF) `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a>{` pursuant to Section 515 of the Treasury and General Government Appropriations Act for Fiscal Year 2001.`}</li>
    </ul>
    <h2 {...{
      "id": "Additional-Resources",
      "style": {
        "position": "relative"
      }
    }}>{`Additional Resources`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://onrr.gov/getting-started/how-leasing-works"
        }}>{`How Leasing Works `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://revenuedata.doi.gov/downloads#Data-Collection-and-Validation"
        }}>{`Data Collection and Validation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://revenuedata.doi.gov/how-revenue-works/audits-and-assurances"
        }}>{`Audits and Assurances`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.doi.gov/ocio/information-quality-act-coordinators"
        }}>{`Information Quality Policy Contacts `}<OpenInNewIcon style={{
            fontSize: 20
          }} mdxType="OpenInNewIcon" /></a></li>
    </ul>
    <h2 {...{
      "id": "Requests-for-Correction-of-Information",
      "style": {
        "position": "relative"
      }
    }}>{`Requests for Correction of Information`}</h2>
    <p>{`If you believe that information ONRR has disseminated does not meet the OMB or DOI Information Quality Guidelines, you may email `}<a parentName="p" {...{
        "href": "mailto:nrrd@onrr.gov"
      }}>{`nrrd@onrr.gov`}</a>{` a request for correction.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      